var singleHTOVal = theme.custom.htoSingleProduct;
var singleHTOArr = singleHTOVal.split(', ');

$(document).ready(function() {
    //console.log('new custom cart');
    // check if there are kore than 1 hto
    if ($('.htoForceQty').length > 0) {
        var htoUpdateLink = $('.htoForceQty').attr('href');  
        window.location.href = htoUpdateLink;
    }
    if (products != null) {
        if (product_count > 0) {
            buildHTOCart(htoStorage);
        } 
    }
    // on cart remove
    $('body').on('click', '.cart__item-remove', function() {
        var isHTO = $(this).closest('.cart__row').hasClass('hto-product');
        var variantID = $(this).closest('.cart__row').attr('data-variant-id');
        var itemKeys = '';
        if (isHTO == true) {
            // hto remove
            var confirmMsg = theme.custom.removeHTO;
        } else { 
            // normal product remove
            var confirmMsg = theme.custom.removeItem;
            variantID = $(this).closest('.cart__row').attr('data-key');
            itemKeys = $(this).closest('.cart__row').attr('data-item-keys');
        }
        console.log(itemKeys);
        cartRemoveConfirm(isHTO, confirmMsg, variantID, itemKeys);
        return false;  
    });

    showEmptyCart();
    enableDisableCheckout();


    $('#CartPage').removeClass('loading');

    document.addEventListener('click', function (e) {
      const stickyBtn = e.target.closest('[data-sticky-checkout-btn]');
      if (!stickyBtn) return;

      e.preventDefault(); // prevent default behavior

      const checkoutBtn = document.querySelector('[name="checkout"]');
      if (checkoutBtn) {
        checkoutBtn.click();
      }
    });
});

function buildHTOCart(htoStorage) {
    if (htoStorage != null) {
        var htoArr = [1,2,3,4];
        var singleArrFlag = false; 
        $.each(htoStorage, function(index, val) {
            if ($.inArray(val.productname, singleHTOArr) > -1) {   
                singleArrFlag = true; 
                htoArr = [1];
            }    
        });
        var titleRow = '<tr class="cart__row responsive-table__row cart__row_title hto_title"><td colspan="4" class="cart__cell--image ">'+theme.custom.htoCartTitle+'</td></tr>';
        var htoCartDisclaimer = '<tr class="cart__row disclaimer"><td colspan="4" class="text-center" style="padding: 10px; font-size: 13px;">'+theme.custom.htoCartDisclaimer+'</td></tr>';
        var emptyHTORow =  '<tr class="cart__row responsive-table__row hto-product-empty">'+
                                '<td class="cart__cell--image text-center">'+
                                    '<div class="empty_image_slot">'+
                                        '{{htoIndex1}}'+
                                    '</div>'+
                                '</td>'+
                                '<td class="cart__cell--content">'+
                                    '<div class="js-qty">'+
                                        '<div class="home_try_on_container">'+
                                            '<span class="home_try_on">'+theme.custom.htoCartTitle+'</span> <span class="home_try_on">({{htoCount}})</span>'+
                                            '<div class="add_another_item">'+
                                            '<a href="/collections/all">'+
                                                theme.custom.htoCartAddMsg+
                                            '</a>'+     
                                            '</div>'+
                                        '</div>'+
                                    '</div>'+
                                '</td>'+
                                '<td class="cart__cell--quantity">'+
                                '</td>'+
                                '<td class="cart__cell--total">'+
                                    '<div class="cart__cell--total_inner_container">'+
                                        '<span class="cart__item-add" aria-label="'+theme.custom.htoCartAddMsg+'" title="'+theme.custom.htoCartAddMsg+'">'+
                                            '<a href="/collections/all">'+
                                            theme.custom.htoCartAdd+
                                            '</a>'+ 
                                        '</span>'+
                                    '</div>'+
                                '</td>'+
                           '</tr>';

        var productHTORow =  '<tr data-uid="{{itemUID}}" data-mainid="{{itemID}}" data-title="{{itemTitleVal}}" data-variant-id="{{itemID}}" class="cart__row responsive-table__row hto-product">'+
                                '<td class="cart__cell--image text-center">'+
                                    '<a href="{{itemURL}}" class="cart__image">'+
                                        '<label class="qtyBubble">1</label>'+
                                        '<img src="{{itemImg}}" alt="{{itemTitle}}">'+
                                    '</a>'+
                                '</td>'+
                                '<td class="cart__cell--content">'+
                                    '<div class="home_try_on_container">'+
                                        '<span class="home_try_on">'+theme.custom.htoCartTitle+'</span> <span class="home_try_on">({{htoCount}})</span>'+
                                    '</div>'+
                                    '<div class="h5 product_title">'+
                                        '<a href="{{itemURL}}">'+
                                        '{{itemTitle}}'+
                                        '</a>'+
                                    '</div>'+
                                    '<div class="cart__item-total">'+
                                            '$0.00'+
                                        '</div>'+
                                    '<p class="variant_color">'+
                                        '<a href="{{itemURL}}">'+
                                        '{{itemProp}}'+
                                        '</a>'+
                                    '</p>'+
                                    '<div class="cart__item-remove">'+
                                            theme.custom.htoCartRemove+
                                        '</div>'+
                                '</td>'+
                                '<td class="cart__cell--quantity">'+
                                    '<div class="quantity_container">'+
                                        '<div class="cart_fake_selector">'+
                                        '</div>'+
                                        '<div class="cart__item-remove">'+
                                            theme.custom.htoCartRemove+
                                        '</div>'+
                                    '</div>'+
                                '</td>'+
                                '<td class="cart__cell--total">'+
                                    '<div class="cart__cell--total_inner_container">'+
                                        '<div class="cart__item-total">'+
                                            '$0.00'+
                                        '</div>'+
                                        '<div class="quantity_container mobile">'+
                                            '<div class="cart__item-remove ">'+
                                                theme.custom.htoCartRemove+
                                            '</div>'+
                                        '</div>'+
                                    '</div>'+
                                '</td>'+
                           '</tr>';                

        $('#HTOProducts').html('');

        $('#HTOProducts').append(titleRow);

        var noHTOTag = theme.custom.noHTOTag;
        var invalidHTO = [];

        $.ajaxSetup({
            async: false
        });
        var invalidHTOArrUIID = [];
        var duplicateHTOUIID = [];
        var sizesMap =  theme.custom.filterSizesMap.split(",");
        var seen = {};
        $.each(htoStorage, function(index, htoEntry) {
            // remove duplicate HTO
            var prodNameColorSize = htoEntry.productname+'|'+htoEntry.variantcolor+'|'+htoEntry.eyeSize;
            if (seen[prodNameColorSize]) {
                //console.log(htoEntry.uid);
                invalidHTO.push(htoEntry.uid);
                return false; // Remove duplicate
            }
            seen[prodNameColorSize] = true; // Mark as seen


            var reqURL =  htoEntry.url;
            var path = reqURL.split("?")[0];
            var productPath = path.match(/\/products\/[a-z0-9-]+/i)?.[0] || "";
            $.each(sizesMap, function (index, value) {
                var sizePrefix = '-'+value.split(': ')[1];
                productPath = productPath.replace(sizePrefix, '')    
            });
            productPath = productPath+'?view=variant-list';
            var variantJSON = [];
            $('.htoVariantInfo').load(productPath, function(response, status, xhr) {
                variantJSON = JSON.parse(response);
            });
            var color = htoEntry.variantcolor;
            var size = htoEntry.eyeSize;
            var isAvailable = true

            var firstOpt = variantJSON[0].option1_name;
            //console.log('firstOpt222', firstOpt);



            var matchingVariant = variantJSON.find(item =>
                item.option1 === color && item.option2.includes(size)
            );
            if (firstOpt.indexOf('Size') > -1) {
                //console.log('firstOpt333');
                matchingVariant = variantJSON.find(item =>
                    item.option2 === color && item.option1.includes(size)
                );
            }
            //console.log(matchingVariant);
            if (matchingVariant === undefined && size === undefined) {
                matchingVariant = variantJSON.find(item =>
                    item.option1 === color
                );
            }

            var isAvailable = matchingVariant ? matchingVariant.available : null;

            if (isAvailable == false || isAvailable == null) {
                invalidHTOArrUIID.push(htoEntry.uid);
            }

            var handle = htoEntry.url.match(/\/products\/([^/?]+)/); 
            handle = handle ? handle[1] : null;
            var uid = htoEntry.uid;
            var color = htoEntry.variantcolor;
            var eyeSize = parseInt(htoEntry.eyeSize);

            $.each(disableHto, function(index, disableHto) {
              var sizes = disableHto.Size;
              var sizeArr = [];
              if (sizes != '') {
                sizeArr = sizes.match(/\d+/g).map(Number);
              }
              var colorArr = disableHto.Color.split(', ');
              if (handle.indexOf(disableHto.handle) > -1  && $.inArray(eyeSize, sizeArr) > -1 && $.inArray(color, colorArr) > -1) {
                invalidHTOArrUIID.push(uid);
              }
            });
            //console.log('htoEntry', productPath, variantJSON, matchingVariant, isAvailable);
        });  
         
        if (invalidHTOArrUIID.length > 0) {
            console.log('invalidHTOArrUIID Arr', invalidHTOArrUIID);
            //alert('remove');
            Swal.fire({
                  title: theme.custom.htoOOSTitle,
                  text: theme.custom.htoOOSMsg,
                  showCancelButton: false,
                  confirmButtonText: "Ok",
                  cancelButtonText: "Go Back",
                  type: 'warning',
                  reverseButtons: true,
                  customClass: {
                      cancelButton: 'btn btn-sm btn-remove',
                      denyButton: 'btn btn-sm btn-remove',
                      confirmButton: 'btn btn-sm btn-primary'
                  }
            }).then(function(del) {
                  if (del.isConfirmed) {
                      
                    $.each(invalidHTOArrUIID, function(index, val) {
                        console.log('invalidHTOArrUIID', val);
                        removeHTOcart(val)
                    });
                    setTimeout(function() {
                        location.reload();
                    }, 100);
                    
                  }
            })

            
        }  
        $.each(htoArr, function(index, val) {
            //console.log('htoArr');
            //console.log('htoArrindex:'+index);
            //console.log('htoArrindex:'+val);
            var htoEntry = htoStorage[index];
            var htoIndex = index;
            var htoIndex1 = index + 1;
            var htoCount = htoIndex1+'/'+htoArr.length;

            
            if (htoEntry === undefined) {
                // empty    
                var emptyItemHTORow = emptyHTORow;
                emptyItemHTORow = emptyItemHTORow.replace(/{{htoCount}}/g, htoCount);
                emptyItemHTORow = emptyItemHTORow.replace(/{{htoIndex1}}/g, htoIndex1);
                $('#HTOProducts').append(emptyItemHTORow);
            } else {
                var itemHTORow = productHTORow;
                var htoProp = '';
                if (htoEntry.variantcolor) {
                   htoProp =  htoEntry.variantcolor;
                }
                if (htoEntry.size) {
                    htoProp = htoProp+' | '+htoEntry.size;
                }    
                if (htoEntry.eyeSize) {
                    htoProp = htoProp+'<br> Eye Size: '+htoEntry.eyeSize;
                }    
                //console.log(htoEntry.imageurl)
                itemHTORow = itemHTORow.replace(/{{itemUID}}/g, htoEntry.uid);
                itemHTORow = itemHTORow.replace(/{{itemTitleVal}}/g, htoEntry.productname);
                itemHTORow = itemHTORow.replace(/{{itemID}}/g, htoEntry.variantid);
                itemHTORow = itemHTORow.replace(/{{htoCount}}/g, htoCount);
                itemHTORow = itemHTORow.replace(/{{htoIndex1}}/g, htoIndex1);
                itemHTORow = itemHTORow.replace(/{{itemTitle}}/g, htoEntry.productname.replace(' [V2]', '')); 
                if (htoEntry.imageurl != undefined) {
                    itemHTORow = itemHTORow.replace(/{{itemImg}}/g, htoEntry.imageurl.replace('_300x300.jpg?', '.jpg?').replace('_300x300.png?', '.png?').replace('_540x.jpg?', '.jpg?').replace('_540x.png?', '.png?').replace('.png?', '_120x.png?'));
                }
                itemHTORow = itemHTORow.replace(/{{itemURL}}/g, htoEntry.url);
                itemHTORow = itemHTORow.replace(/{{itemProp}}/g, htoProp);
                $('#HTOProducts').append(itemHTORow);

                var prodHandle = htoEntry.url.split('products/')[1].split('?')[0];
                var varID = htoEntry.variantid;
                var uID = htoEntry.uid;

                // hto has no tag value do ajax 
                var full_url = 'https://' + Shopify.shop + '/products/' + prodHandle + '.json';
                var prodTagArr = [];
                $.ajax({
                    url: full_url,
                    success: function(data) {
                      //console.log(data);
                      prodTagArr = data.product.tags.split(', ');
                      // invalid HTO present in tag
                      //console.log(prodTagArr);
                      if ($.inArray(noHTOTag, prodTagArr) > -1) {
                          //invalidHTO.push(varID);
                          invalidHTO.push(uID);
                      }
                    }
                });
            }
        });
        $.ajaxSetup({
            async: true
        });
        // remove invalid HTO
        if (invalidHTO.length > 0) {
             console.log('invalidHTO', invalidHTO);
          Swal.fire({
              title: theme.custom.invalidHTO,
              text: theme.custom.invalidHTOMsg,
              showCancelButton: false,
              confirmButtonText: "Ok",
              cancelButtonText: "Go Back",
              type: 'warning',
              reverseButtons: true,
              customClass: {
                  cancelButton: 'btn btn-sm btn-remove',
                  denyButton: 'btn btn-sm btn-remove',
                  confirmButton: 'btn btn-sm btn-primary'
              }
          }).then(function(del) {
              if (del.isConfirmed) {
                 
                  $.each(invalidHTO, function(index, val) {
                    removeHTOcart(val)
                  });
                  //location.reload();
              }
          })
        }

        $('#HTOProducts').append(htoCartDisclaimer);
    } else {
        $('#HTOProducts').html('');
    }

}


function removeHTOcart(uid) {

    // var cartVariantID = variantID;
    var removeIndex = -1;
    // var removeIndex = index;

    
    // find the index of  hto variant id
    $('body').addClass('ajaxLoading');
    setTimeout(function() {
        $.each(htoStorage, function(index, val) {
            if (val.uid == uid) {
                removeIndex = index;
            } 
        });
        // remove hto from cart and storage

        htoStorage.splice(removeIndex, 1);  
        if (htoStorage.length > 0) {
            console.log('htoStorage', htoStorage);
            window.localStorage.setItem("products", JSON.stringify(htoStorage));
            buildHTOCart(htoStorage);
        } else {
            // remove product localStorage and hto product
            window.localStorage.removeItem("products");
            buildHTOCart(htoStorage); 
        }   
        //updateCartCount();
        updateCartCount('remove hto');
        showEmptyCart();
        enableDisableCheckout();

        $.ajaxSetup({ async: false });
        pushHTOTracking(); 
        $.ajaxSetup({ async: true });

        $('body').removeClass('ajaxLoading'); 
    }, 300);
    

}

function cartRemoveConfirm(isHTO, confirmMsg, variantID, itemKeys) { 
    Swal.fire({
        title: confirmMsg,
        showCancelButton: true,
        confirmButtonText: "Remove",
        cancelButtonText: "Go Back",
        type: 'warning',
        reverseButtons: true,
        customClass: {
            cancelButton: 'btn btn-sm btn-remove',
            denyButton: 'btn btn-sm btn-remove',
            confirmButton: 'btn btn-sm btn-primary'
        }   
    }).then(function(del) {
        if (del.isConfirmed) {
            if (isHTO == true) {
                // removeHTO
                console.log('swal variantID:'+variantID);
                removeHTOcart(variantID)
            } else {
                updateProductQty(itemKeys, 0);
            }   
        }
    })

}
function updateProductQty(itemKeys, qty) {
    var xdata = { updates: {} };
    var xqty = qty;
    var xitemKeys = itemKeys;

    var itemsArray = xitemKeys.split(', ');

    for (i = 0; i < itemsArray.length; i++) {
        xdata.updates[itemsArray[i]] = qty;
    }

    console.log(itemKeys);
    console.log(xdata);


    $.ajaxSetup({
        async: false,
    });
    $('body').addClass('ajaxLoading');
    setTimeout(function() {
        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: xdata,
            dataType: 'json',
            success: function() {
               
            }       
        });
        if (xqty == 0) {
            $('.cart__row[data-item-keys="'+xitemKeys+'"]').remove();
        }
        $('.site-header__cart-indicator').attr('data-cart-count', $('#CartProducts .cart-product').length);
        updateCartCount('update cart');
        showEmptyCart();
        enableDisableCheckout();
        $('body').removeClass('ajaxLoading'); 
    }, 300);
    $.ajaxSetup({
        async: true,
    });

    
}
function showEmptyCart() {
    if ($('.cart__row[data-mainid]').length == 0) {
      $('#cart_content_container').hide();
      $('#cart_empty_content_container').show();
      $('[data-sticky-checkout]').hide();
    } 
}
function enableDisableCheckout() {
    // cart item present enable checkout button
    var products = JSON.parse(localStorage.getItem("products")) == null ? [] : JSON.parse(localStorage.getItem("products"));
    var htoCount = products.length;
    $.each(htoStorage, function(index, val) {
        if ($.inArray(val.productname, singleHTOArr) > -1) {   
            htoCount = 4;
        }        
    });
    if ($('.cart__row.cart-product').length > 0) {
        //console.log('has product');
        $('#CartPageCheckOut [name="checkout"], [data-sticky-checkout-btn]').removeAttr('disabled');
    } else {
        //console.log('zero product');
        if (htoCount > 0) {
            if (htoCount < 4) {
                // hto les than 4
                $('#CartPageCheckOut [name="checkout"], [data-sticky-checkout-btn]').attr('disabled', 'disabled');
            } else {
                // 4 hto
                $('#CartPageCheckOut [name="checkout"], [data-sticky-checkout-btn]').removeAttr('disabled');
                
            }  
        } else {
           $('#CartPageCheckOut [name="checkout"]').attr('disabled'); 
        }
    }    
    if (htoCount < 4 && $('.cart__row.hto-product').length != 0) {
        $('.htoMsg').show();
    }  else {
        $('.htoMsg').hide();
    }   


}




